export default __webpack_public_path__ + "static/media/advicegradissuegfx-12.0220a30d.png";